import { toast } from 'react-toastify'

import { int } from '@zxing/library/esm/customTypings'

import * as api from '../../api/keyMappingApi'
import {
  DeviceKeyMappingsRequestDto,
  DeviceKeyMappingsResponseDto,
  SearchKeyMappingsRequestDto,
  SearchKeyMappingsResponseDto,
} from '../../api/kmsapiclient'
import * as constants from '../../utils'
import {
  DeviceKeyMappingInfo,
  DeviceKeyMappingsState,
} from '../reducers/initialState'

import {
  ADD_KEY_MAPPINGS_SUCCESS,
  BaseActionType,
  DELETE_KEY_MAPPINGS_SUCCESS,
  LOAD_KEY_MAPPINGS_SUCCESS,
  LOAD_MORE_KEY_MAPPINGS_SUCCESS,
  UPDATE_GET_KEY_MAPPINGS_REQUEST,
  UPDATE_KEY_MAPPINGS_PAGE_NUM,
  UPDATE_KEY_MAPPINGS_SUCCESS,
  UPLOAD_KEY_MAPPINGS_SUCCESS,
} from './actionTypes'
import { apiCallError, beginApiCall, endApiCall } from './apiStatusActions'

type DeviceKeyMapping = DeviceKeyMappingInfo

export function addKeyMapping(keyMapping: DeviceKeyMappingsRequestDto) {
  return async function (dispatch) {
    dispatch(beginApiCall())
    try {
      const result: DeviceKeyMappingsResponseDto =
        await api.addKeyMappingsAsync(keyMapping)
      if (result != null) {
        dispatch(addKeyMappingSuccess(result))
        toast.success('Permission Added')

        dispatch(updateKeyMappingsPageNum(1))
      } else {
        dispatch(endApiCall())
        toast.error('Add Permission Failed')
      }
    } catch (error) {
      toast.error('Add Permission Failed')
      dispatch(apiCallError())
      throw error
    }
  }
}

export function deleteKeyMapping(keyMapping: DeviceKeyMapping) {
  return async function (dispatch) {
    dispatch(beginApiCall())
    try {
      const result: string = await api.removeKeyMappingsAsync(keyMapping)
      if (result === 'Success') {
        dispatch(deleteKeyMappingSuccess(keyMapping))
        toast.success('Permission Deleted')
      } else {
        dispatch(endApiCall())
        toast.error('Delete Permission Failed')
      }
    } catch (error) {
      toast.error('Delete Permission Failed')
      dispatch(apiCallError())
      throw error
    }
  }
}

export function updateKeyMapping(keyMapping: DeviceKeyMapping) {
  return async function (dispatch) {
    dispatch(beginApiCall())
    try {
      const result: DeviceKeyMappingsResponseDto =
        await api.updateKeyMappingsAsync(keyMapping)
      if (result != null) {
        dispatch(updateKeyMappingSuccess(result))
        toast.success('Permission Updated')
      } else {
        dispatch(endApiCall())
        toast.error('Update Permission Failed')
      }
    } catch (error) {
      toast.error('Update Permission Failed')
      dispatch(apiCallError())
      throw error
    }
  }
}

export function uploadKeyMapping(keyMappings: DeviceKeyMapping) {
  return async function (dispatch, getState) {
    dispatch(beginApiCall())
    try {
      const result: DeviceKeyMappingsResponseDto[] =
        await api.uploadKeyMappingsAsync(keyMappings)
      if (result != null) {
        dispatch(uploadKeyMappingSuccess(result))
        toast.success('Permissions Uploaded')

        dispatch(updateKeyMappingsPageNum(1))
      } else {
        dispatch(endApiCall())
        toast.error('Upload Permissions Failed')
      }
    } catch (error) {
      toast.error('Upload Permissions Failed')
      dispatch(apiCallError())
      throw error
    }
  }
}

export function loadKeyMappings(request) {
  return search(request, loadKeyMappingsSuccess)
}

export function loadMoreKeyMappings(request) {
  return search(request, loadMoreKeyMappingsSuccess)
}

const search = (request: SearchKeyMappingsRequestDto, successFunc) => {
  return async function (dispatch, getState) {
    dispatch(beginApiCall())
    try {
      const results: SearchKeyMappingsResponseDto =
        await api.searchKeyMappingsAsync(request)
      const newRequest = {
        ...request,
        continuationTokenKey: results ? results.continuationTokenKey : null,
      }
      dispatch(updateKeyMappingsRequest(newRequest))

      dispatch(successFunc(results))

      const length: int = getState().keyMappings.deviceKeyMappings.length
      dispatch(
        updateKeyMappingsPageNum(
          length === 0
            ? 0
            : Math.floor((length - 1) / constants.maxRecordsPerApiRequest) *
                (constants.maxRecordsPerApiRequest / constants.recordsPerPage) +
                1,
        ),
      )
    } catch (error) {
      dispatch(apiCallError())
      throw error
    }
  }
}

const loadKeyMappingsSuccess = (
  keyMappings: DeviceKeyMappingsState,
): BaseActionType => ({
  type: LOAD_KEY_MAPPINGS_SUCCESS,
  payload: keyMappings,
})

const loadMoreKeyMappingsSuccess = (
  keyMappings: DeviceKeyMappingsState,
): BaseActionType => ({
  type: LOAD_MORE_KEY_MAPPINGS_SUCCESS,
  payload: keyMappings,
})

const updateKeyMappingsRequest = (
  request: SearchKeyMappingsRequestDto,
): BaseActionType => ({
  type: UPDATE_GET_KEY_MAPPINGS_REQUEST,
  payload: request,
})

export function updateKeyMappingsPageNum(pageNum: number): BaseActionType {
  return {
    type: UPDATE_KEY_MAPPINGS_PAGE_NUM,
    payload: pageNum,
  }
}

const addKeyMappingSuccess = (
  keyMapping: DeviceKeyMappingsResponseDto,
): BaseActionType => ({
  type: ADD_KEY_MAPPINGS_SUCCESS,
  payload: keyMapping,
})

const deleteKeyMappingSuccess = (
  keyMapping: DeviceKeyMappingInfo,
): BaseActionType => ({
  type: DELETE_KEY_MAPPINGS_SUCCESS,
  payload: keyMapping,
})

const updateKeyMappingSuccess = (
  keyMapping: DeviceKeyMappingsResponseDto,
): BaseActionType => ({
  type: UPDATE_KEY_MAPPINGS_SUCCESS,
  payload: keyMapping,
})

const uploadKeyMappingSuccess = (
  keyMappings: DeviceKeyMappingsResponseDto[],
): BaseActionType => ({
  type: UPLOAD_KEY_MAPPINGS_SUCCESS,
  payload: keyMappings,
})
